import { render, staticRenderFns } from "./portfolio.vue?vue&type=template&id=45c7fc98&"
import script from "./portfolio.vue?vue&type=script&lang=js&"
export * from "./portfolio.vue?vue&type=script&lang=js&"
import style0 from "./portfolio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports